'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _three = require('three');

var THREE = _interopRequireWildcard(_three);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CameraDescriptorBase2 = require('./CameraDescriptorBase');

var _CameraDescriptorBase3 = _interopRequireDefault(_CameraDescriptorBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrthographicCameraDescriptor = function (_CameraDescriptorBase) {
  _inherits(OrthographicCameraDescriptor, _CameraDescriptorBase);

  function OrthographicCameraDescriptor(react3Instance) {
    _classCallCheck(this, OrthographicCameraDescriptor);

    var _this = _possibleConstructorReturn(this, (OrthographicCameraDescriptor.__proto__ || Object.getPrototypeOf(OrthographicCameraDescriptor)).call(this, react3Instance));

    _this.propTypes = _extends({}, _this.propTypes, {

      left: _propTypes2.default.number.isRequired,
      right: _propTypes2.default.number.isRequired,
      top: _propTypes2.default.number.isRequired,
      bottom: _propTypes2.default.number.isRequired,
      near: _propTypes2.default.number,
      far: _propTypes2.default.number
    });

    _this.propUpdates = _extends({}, _this.propUpdates, {

      left: _this._updateAndRefreshProjection.bind(_this, 'left'),
      right: _this._updateAndRefreshProjection.bind(_this, 'right'),
      top: _this._updateAndRefreshProjection.bind(_this, 'top'),
      bottom: _this._updateAndRefreshProjection.bind(_this, 'bottom'),
      fov: _this._updateFov,
      far: _this._updateFar
    });
    return _this;
  }

  _createClass(OrthographicCameraDescriptor, [{
    key: '_updateFov',
    value: function _updateFov(threeObject, fov) {
      threeObject.fov = fov;

      threeObject.userData._needsProjectionMatrixUpdate = true;
    }
  }, {
    key: '_updateFar',
    value: function _updateFar(threeObject, far) {
      threeObject.far = far;

      threeObject.userData._needsProjectionMatrixUpdate = true;
    }
  }, {
    key: 'construct',
    value: function construct(props) {
      return new THREE.OrthographicCamera(props.left, props.right, props.top, props.bottom, props.near, props.far);
    }
  }, {
    key: '_updateAndRefreshProjection',
    value: function _updateAndRefreshProjection(propName, camera, value) {
      camera[propName] = value;

      camera.userData._needsProjectionMatrixUpdate = true;
    }
  }]);

  return OrthographicCameraDescriptor;
}(_CameraDescriptorBase3.default);

module.exports = OrthographicCameraDescriptor;


//////////////////
// WEBPACK FOOTER
// ./~/react-three-renderer/lib/descriptors/Object/Camera/OrthographicCameraDescriptor.js
// module id = 1357
// module chunks = 1